import { Component } from '@angular/core';

@Component({
  selector: 'app-update-procedure',
  templateUrl: './update-procedure.component.html',
  styleUrls: ['./update-procedure.component.css']
})
export class UpdateProcedureComponent {

}
